import renderHTML from 'react-render-html';

export default function convertAllLinks(string) {
  let stringWithLinks = string;

  if (string.includes('<tcm_link')) {
    const el = document.createElement('span');
    el.innerHTML = string;

    el.querySelectorAll('tcm_link').forEach((link) => {
      const type = link.getAttribute('type');
      const data = link.getAttribute('data');
      const anchor = document.createElement('a');
      anchor.textContent = link.textContent;

      if (type === 'externalLink') {
        anchor.href = data;
        anchor.setAttribute('target', '_blank');
      } else {
        const baseUrl = window.location.origin;
        if (type === 'internalSessionLink') {
          anchor.href = `${baseUrl}/Session/${data}`;
        } else {
          anchor.href = `${baseUrl}/Content/${data}`;
        }
      }
      link.parentNode.replaceChild(anchor, link);
    });

    stringWithLinks = el.innerHTML;
  }

  return renderHTML(stringWithLinks);
}



// WEBPACK FOOTER //
// ./library/app/utils/convertTcmLink.js